import { InputLabel, Select, MenuItem } from "@mui/material";
import FormField from "./form-controls/form-field";

interface FilterDropdownProps {
    id: string;
    placeholder?: string;
    label: string;
    defaultValue: string;
    options: { key: string; value: string, label: string }[];
    onChange(value: string): void;
}

const FilterDropdown: React.FC<FilterDropdownProps> = (props) => {
    return (
        <FormField>
            <InputLabel id={`${props.id}-label`}>{props.placeholder}</InputLabel>
            <Select
                id={props.id}
                labelId={`${props.id}-label`}
                label={props.label}
                style={{ height: "50px", backgroundColor: "#FFFFFF" }}
                defaultValue={props.defaultValue}
                onChange={(e) => props.onChange(e.target.value)}
            >
                {props.options.map(option => (
                    <MenuItem key={option.key} value={option.value}>{option.label}</MenuItem>
                ))}
            </Select>
        </FormField>
    );
}

export default FilterDropdown;